import React from "react";
import { Popover, OverlayTrigger } from "react-bootstrap";
import _ from "lodash";
import NumberFormat from "react-number-format";
import { CSVLink } from "react-csv";
import Styled from "../../../operations/style";
import MapImage from '../../../../containers/assets/new-map-without-buttons.png';
import { mapDotsData } from '../../../../data/customer-analysis';

const popoverComponent = (num, customers_preferences, customer_demands) => {
  const customer_preferences = customers_preferences.find(
    i => i.customer === num
  );
  if (!customer_preferences) {
    return <div />;
  }

  const customer_demand = customer_demands.find(i => i.customer === num);
  if (!customer_demand) {
    return <div />;
  }

  const {
    customer,
    segment,
    min_price,
    max_price,
    min_temp_range,
    min_sensitivity,
    min_power,
    min_pixels
  } = customer_preferences;

  const min_price_object = (
    <NumberFormat
      thousandSeparator=","
      decimalSeparator="."
      prefix="$"
      value={min_price.toFixed(2)}
      displayType="text"
    />
  );
  const max_price_object = (
    <NumberFormat
      thousandSeparator=","
      decimalSeparator="."
      prefix="$"
      value={max_price.toFixed(2)}
      displayType="text"
    />
  );
  const temp_range_rank_object = (
    <NumberFormat
      thousandSeparator=","
      decimalSeparator="."
      value={min_temp_range.toFixed(1)}
      displayType="text"
    />
  );
  const sensitivity_rank_object = (
    <NumberFormat
      thousandSeparator=","
      decimalSeparator="."
      value={min_sensitivity.toFixed(1)}
      displayType="text"
    />
  );
  const power_rank_object = (
    <NumberFormat
      thousandSeparator=","
      decimalSeparator="."
      value={min_power.toFixed(1)}
      displayType="text"
    />
  );
  const pixels_rank_object = (
    <NumberFormat
      thousandSeparator=","
      decimalSeparator="."
      value={min_pixels.toFixed(1)}
      displayType="text"
    />
  );

  const { demand } = customer_demand;
  const demand_object = (
    <NumberFormat
      thousandSeparator=","
      decimalSeparator="."
      value={demand.toFixed(0)}
      displayType="text"
    />
  );

  return (
    <Popover
      id={`popover-map-us-${num}`}
      title={<span><span>{num}</span> {mapDotsData[num - 1].title}</span>}
      bsClass="map-popover popover"
    >
      <b>Customer Name:</b> {customer}
      <br />
      <b>Segment:</b> {segment}
      <br />
      <b>Demand:</b> {demand_object} units
      <br />
      <b>Price Range:</b> {min_price_object} to {max_price_object}
      <br />
      <br />
      <b>Minimum Features:</b>
      <br />
      <table>
        <tr>
          <td className="no-left-spacing">Resolution: {pixels_rank_object}</td>
          <td className="no-right-spacing">
            Sensitivity: {sensitivity_rank_object}
          </td>
        </tr>
        <tr>
          <td className="no-left-spacing">Power: {power_rank_object}</td>
          <td className="no-right-spacing">
            Temp Range: {temp_range_rank_object}
          </td>
        </tr>
      </table>
    </Popover>
  );
};

function getCSVData(customer_preferences, customer_demands) {
  let data = [];

  customer_preferences.forEach(customer_preference => {
    const customer_demand = customer_demands.find(
      i => i.customer === customer_preference.customer
    );

    data.push({
      customer: customer_preference.customer,
      round: customer_preference.round_number,
      segment: customer_preference.segment,
      demand: customer_demand ? customer_demand.demand : 0,
      price_lower_bound: "$" + customer_preference.min_price.toFixed(2),
      price_higher_bound: "$" + customer_preference.max_price.toFixed(2),
      min_resolution: customer_preference.min_pixels,
      min_sensitivity: customer_preference.min_sensitivity,
      min_power: customer_preference.min_power,
      min_temperature_range: customer_preference.min_temp_range
    });
  });

  return data;
}

function Map(props) {
  const { customer_preferences, customer_demands } = props;
  const csvData = getCSVData(customer_preferences, customer_demands);
  const csvHeaders = [
    { key: "customer", label: "Customer" },
    { key: "round", label: "Round" },
    { key: "segment", label: "Segment" },
    { key: "demand", label: "Demand" },
    { key: "price_lower_bound", label: "Price Lower Bound" },
    { key: "price_higher_bound", label: "Price Higher Bound" },
    { key: "min_resolution", label: "Min. Resolution" },
    { key: "min_sensitivity", label: "Min. Sensitivity" },
    { key: "min_power", label: "Min Power" },
    { key: "min_temperature_range", label: "Min. Temperature Range" }
  ];

  return (
    <div className="col-md-6 col-xs-12">
      <div className="market-analysis">
        <div className="market-analysis">
          <div className="row img-map">
            <div className="mapUS">
              <Styled.WhiteBlock width="100%">
                <Styled.GoogleMap>
                  <img src={MapImage} alt="map" />

                  {_.range(1, 15).map(num => (
                    <OverlayTrigger
                      key={num}
                      trigger={["hover", "focus"]}
                      placement="bottom"
                      overlay={popoverComponent(
                        num,
                        customer_preferences,
                        customer_demands
                      )}
                    >
                      <Styled.MapDot
                        xPercentage={mapDotsData[num - 1].x}
                        yPercentage={mapDotsData[num - 1].y}
                      >
                        {num}
                      </Styled.MapDot>
                    </OverlayTrigger>
                  ))}

                </Styled.GoogleMap>
              </Styled.WhiteBlock>
            </div>
          </div>

          <div className="region">
            {csvData.length > 0 && (
              <div className="market-analysis-download-link">
                <CSVLink
                  data={csvData}
                  headers={csvHeaders}
                  separator=","
                  filename={`market-analysis-round-${csvData[0].round}.csv`}
                  target="_blank"
                >
                  Download
                </CSVLink>
              </div>
            )}
            <h4>Region: US</h4>
            <p>Extra customer information</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/ceo/analysis/market/map.js